import State from './state';

export function getChildrenData(state = State) {
  return state.childrenData || [];
}

export function getListChildrenSelectFormat(state = State) {
  return state.childrenDataFormatted || [];
}

export function getChildData(state = State) {
  return (id) => {
    let to_retun = {};
    state.childrenData.forEach((element) => {
      if (element.id == id) {
        to_retun = element;
      }
    });
    return to_retun;
  };
}

export function getDailyGoal(state = State) {
  return state.dailyGoal;
}

export function getChildrenOrder(state = State) {
  return state.childrenOrder || [];
}

export function getChildChallengeOrder(state = State) {
  return state.childChallengeOrder;
}

export function getFavoriteSkills(state = State) {
  return state.favoriteSkills || [];
}

export function getChildsCliniciansReport(state = State) {
  return state.childsCliniciansReport || [];
}
